import classNames from 'classnames';
import moment from 'moment';
import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { useLAPSearchUrl } from '@sbu/hooks.url';

import { Collapse } from 'shared/components/layout/Collapse';
import { Slant } from 'shared/components/utils/Slant';

import { type EntityTypeFieldsAndIndicator } from '../useEntityTypeRecordFields';
import css from './Record.module.scss';
import { RecordDetails } from './RecordDetails';
import { RecordHeader } from './RecordHeader';
import { RecordType } from './schema';

interface RecordProps {
  className?: any;
  entityTypeFieldsAndIndicator?: EntityTypeFieldsAndIndicator;
  expanded: boolean;
  record: RecordType;
  showExpander?: boolean;
  onExpandCollapse: (record: RecordType) => void;
}

export const Record: FC<React.PropsWithChildren<RecordProps>> = ({
  className,
  entityTypeFieldsAndIndicator,
  expanded,
  onExpandCollapse,
  record,
  showExpander = true,
}) => {
  const history = useHistory();

  const { metadata_sourceMessageId, timestamp } = record ?? {};

  const oneHour = moment.duration('01:00:00');
  const startTime = moment(timestamp).subtract(oneHour).valueOf();
  const endTime = moment(timestamp).add(oneHour).valueOf();

  const normalizedQuery = `_index=sec_record_* metadata_sourceMessageId=${metadata_sourceMessageId}`;
  const rawQuery = `_messageId=${metadata_sourceMessageId}`;

  const normalizedSearchUrl = useLAPSearchUrl({
    query: normalizedQuery,
    startTime,
    endTime,
  });
  const rawSearchUrl = useLAPSearchUrl({ query: rawQuery, startTime, endTime });

  return (
    <div className={classNames(className)}>
      <Slant>
        <div className={css.record}>
          <div className={css.row}>
            <RecordHeader
              expanded={expanded}
              location={history.location}
              onExpandCollapse={onExpandCollapse.bind(this, record)}
              record={record}
              showExpander={showExpander}
              entityTypeFieldsAndIndicator={entityTypeFieldsAndIndicator}
            />
          </div>
          <Collapse expanded={expanded}>
            <RecordDetails
              entityTypeFieldsAndIndicator={entityTypeFieldsAndIndicator}
              normalizedSearchUrl={normalizedSearchUrl}
              rawSearchUrl={rawSearchUrl}
              record={record}
            />
          </Collapse>
        </div>
      </Slant>
    </div>
  );
};
